<template>
    <div class="firm-specific-documents loading-content-container">
        <div v-if="firmSpecificDocumentsLoading > 0" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>
        <b-row v-else class="mb-4">
            <csp-desktop-info-card
                :cols="12"
                icon="inticon-autoclaim_document"
                title="Firmenspezifische Dokumente">
                <b-button v-if="permissions.canCreate" class="mb-3 right" :href="createUrl" variant="primary">
                    Dokument erstellen
                </b-button>
                <div class="clear-float"></div>
                <div class="firm-specific-documents-list">
                    <b-table v-if="tableItems.length" :fields="fields" :items="tableItems" responsive striped>
                        <template v-slot:cell(actions)="data">
                            <div class="table-actions" style="text-align: left">
                                <a v-if="data.item.permissions.canShow"
                                    :href="getFirmSpecificDocumentDetailUrl(data.item.id)" title="Details anzeigen">
                                    <i class="inticon-autoclaim_detail"/>
                                </a>
                                <a v-if="data.item.permissions.canEdit"
                                    :href="getFirmSpecificDocumentEditUrl(data.item.id)" title="Bearbeiten">
                                    <i class="inticon-autoclaim_bearbeiten"/>
                                </a>
                                <a v-if="data.item.permissions.canDelete" href="#" title="Löschen"
                                    @click.prevent="openDeleteConfirmationModal(data.item.id)">
                                    <i class="inticon-autoclaim_loschen"/>
                                </a>
                            </div>
                        </template>
                    </b-table>
                    <b-alert v-else show variant="info">
                        Keine firmenspezifischen Dokumente vorhanden.
                    </b-alert>
                </div>

                <b-modal v-model="isDeleteConfirmationModalOpen" cancel-title="Abbrechen" title="Dokument löschen"
                    @hidden="resetDeleteId" @ok="deleteFirmSpecificDocument">
                    Wollen Sie das Dokument wirklich löschen?
                </b-modal>
            </csp-desktop-info-card>
        </b-row>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        name: 'FirmSpecificDocuments',
        mixins: [FormDataMixin],
        data() {
            const firmId = parseInt(this.$route.params.firmId);
            return {
                firmId,
                firmSpecificDocumentsLoading: 0,
                fields: [
                    {
                        key: 'name',
                        label: 'Bezeichnung des Dokuments',
                    },
                    {
                        key: 'actions',
                        label: 'Aktionen',
                    },
                ],
                tableItems: [],
                permissions: {},
                isDeleteConfirmationModalOpen: false,
                firmSpecificDocumentIdToDelete: null,
            };
        },
        computed: {
            createUrl() {
                return `/de/Schaden-Manager/Firma/firm-specific-documents/firmId/${this.firmId}/Create`;
            },
        },
        mounted() {
            this.loadFirmSpecificDocuments();
        },
        methods: {
            loadFirmSpecificDocuments() {
                this.firmSpecificDocumentsLoading++;
                firmRepository.loadFirmSpecificDocuments(this.firmId).then(
                    (success) => {
                        const firmSpecificDocuments = success.data.attributes.firmSpecificDocuments.data;
                        this.tableItems = firmSpecificDocuments.map((item) => {
                            return {
                                id: item.id,
                                ...item.attributes,
                                ...item.meta,
                            };
                        });

                        this.permissions = success.data.meta.permissions;
                    }
                ).finally(() => {
                    this.firmSpecificDocumentsLoading--;
                });
            },
            getFirmSpecificDocumentDetailUrl(firmSpecificDocumentId) {
                return `/de/Schaden-Manager/Firma/firm-specific-documents/firmId/${this.firmId}`
                    + `/Detail/firmSpecificDocumentId/${firmSpecificDocumentId}`
            },
            getFirmSpecificDocumentEditUrl(firmSpecificDocumentId) {
                return this.getFirmSpecificDocumentDetailUrl(firmSpecificDocumentId)
                    + '?editMode=firmSpecificDocumentBasedata';
            },
            openDeleteConfirmationModal(firmSpecificDocumentId) {
                this.firmSpecificDocumentIdToDelete = firmSpecificDocumentId;
                this.isDeleteConfirmationModalOpen = true;
            },
            deleteFirmSpecificDocument() {
                this.firmSpecificDocumentsLoading++;
                firmRepository.deleteFirmSpecificDocument(this.firmId, this.firmSpecificDocumentIdToDelete).then(() => {
                    flashMessenger.addSuccess('Firmenspezifisches Dokument wurde gelöscht');
                    this.loadFirmSpecificDocuments();
                }).finally(() => {
                    this.firmSpecificDocumentsLoading--;
                    this.resetDeleteId();
                });
            },
            resetDeleteId() {
                this.firmSpecificDocumentIdToDelete = null;
            },
        },
    }
</script>
